
import request from '../../utils/request'
export function addFileInfo(data) {
  return request({
    method: "post",
    url: '/document/addFileInfo',
    data,
    headers: { token: sessionStorage.getItem("token") },
  })
}
export function getDocumentTree(params = {}) {
  return request({
    method: "get",
    url: '/document/getDocumentTree',
    params
  })
}
export function getDocumentsByParents(data) {
  return request({
    method: "get",
    url: '/document/getDocumentsByParents',
    params:data
  })
}
export function searchDocuments(data) {
  return request({
    method: "get",
    url: '/document/searchDocuments',
    params: data
  })
}
export function addFileDirectory(data) {
  return request({
    method: "post",
    url: '/document/addFileDirectory',
    data,
    headers: { token: sessionStorage.getItem("token") },
  })
}
export function delFileDirectory(data) {
  return request({
    method: "get",
    url: '/document/delFileDirectory',
    params: data
  })
}
export function download(params) {
  return request({
    method: "get",
    url: '/document/download',
    params,
    responseType: "blob"
  })
}
export function putInDocument(data) {
  return request({
    method: "get",
    url: '/document/putInDocument',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/docment.js